import original from "../mixins/HandlesTeamMembers"

const handles_team_members = {
    mixins: [original],
    props: {
        project: {
            type: Object,
            required: true
        },
        editable: {
            type: Boolean,
            default: false
        }
    }
}

export default handles_team_members
